import { render, staticRenderFns } from "./PasswordMobileVerify.vue?vue&type=template&id=156f37d3&scoped=true&"
import script from "./PasswordMobileVerify.vue?vue&type=script&lang=js&"
export * from "./PasswordMobileVerify.vue?vue&type=script&lang=js&"
import style0 from "./PasswordMobileVerify.vue?vue&type=style&index=0&id=156f37d3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f37d3",
  null
  
)

export default component.exports